module.exports = __webpack_public_path__ + "img/logomark.334277c9.png";